import cleanString from "../cleanString";

export default function (av_ps) {
  if (av_ps) {
    const math_i = av_ps.math;
    if (math_i) {
      let mathString = "";
      for (let i = 0; i < math_i.length; i++) {
        const e = math_i[i];
        if (e.type === "operator") mathString += e.title;
        else {
          mathString += cleanString(e.title.replaceAll(":", ""));
        }
      }
      return mathString;
    }
  }
  return "";
}
